import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';
import { useQueryState } from 'hooks/useQueryState';
import classes from 'components/widgets/InputPrograms/InputPrograms.module.scss';
import MainTable from 'components/common/Tables/MainTable/MainTable';
import {
    columns,
    defaultColumn,
    initialState,
} from 'components/widgets/CrossProgramRelationships/CrossProgramRelationships.utils';
import { useMemo } from 'react';
import { useQueryGetIntegratedScheduleDetails } from 'api/queries/getIntegratedScheduleDetails.query';

export const CrossProgramRelationships = () => {
    const [metaDataId] = useQueryState('metaDataId');
    const { data, isLoading, isFetching } = useQueryGetIntegratedScheduleDetails({
        fileMetaDataId: Number(metaDataId),
    });

    const integratedScheduleDetails = useMemo(() => {
        return data ? data.integratedScheduleDetails : [];
    }, [data]);

    return (
        <WidgetWithTitle title={`Cross Program Relationships (${integratedScheduleDetails.length})`}>
            <div className={classes.container}>
                <MainTable
                    columns={columns}
                    initialState={initialState}
                    data={integratedScheduleDetails}
                    defaultColumn={defaultColumn}
                    isLoading={isLoading || isFetching}
                />
            </div>
        </WidgetWithTitle>
    );
};
